import "./App.css";
import { BrowserRouter as Router, Routes , Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Home from "./pages/Home";
import Footer from "./components/Footer";
import AboutPage from "./pages/AboutPage";
import ClassesPage from "./pages/ClassesPage";
import TeachersPage from "./pages/TeachersPage";
import GalleryPage from "./pages/GalleryPage";
import ContactPage from "./pages/ContactPage";
import PanelPage from "./pages/PanelPage";
import ManagementPage from "./pages/Management";
import AdminLogin from "./pages/AdminLogin";
import ProtectedRoute from "./components/ProtectedRoute";
import AdminGallery from "./pages/AdminGallery";
import AdminStaff from "./pages/AdminStaff";
import AdminNews from "./pages/AdminNews";
import AdminClasses from "./pages/AdminClasses";
import AdminSettings from "./pages/AdminSettings";
import AdminFaq from "./pages/AdminFaq";
import AdminTestimonials from "./pages/AdminTestimonials";
import AdminFacilities from "./pages/AdminFacilities";
import AdminInbox from "./pages/AdminInbox";

function App() {
  return (
    <Router>
      <div className="App">
        <Navbar />
        <div style={{minHeight:'90vh'}}>
        <Routes>
          <Route exact path="/" element={<Home />} />
          <Route exact path="/about" element={<AboutPage />} />
          <Route exact path="/classes" element={<ClassesPage />} />
          <Route exact path="/academics" element={<TeachersPage />} />
          <Route exact path="/management" element={<ManagementPage />} />
          <Route exact path="/gallery" element={<GalleryPage />} />
          <Route exact path="/contact" element={<ContactPage />} />
          <Route exact path="/panels" element={<PanelPage />} />
          
          <Route exact path="/admin-login" element={<AdminLogin />} />
          <Route 
            exact 
            path="/admin/inbox" 
            element={
              <ProtectedRoute>
                <AdminInbox />
              </ProtectedRoute>
            } 
          />
          <Route 
            exact 
            path="/admin/gallery" 
            element={
              <ProtectedRoute>
                <AdminGallery />
              </ProtectedRoute>
            } 
          />
          <Route 
            exact 
            path="/admin/staff" 
            element={
              <ProtectedRoute>
                <AdminStaff />
              </ProtectedRoute>
            } 
          />
          <Route 
            exact 
            path="/admin/news" 
            element={
              <ProtectedRoute>
                <AdminNews />
              </ProtectedRoute>
            } 
          />
          <Route 
            exact 
            path="/admin/classes" 
            element={
              <ProtectedRoute>
                <AdminClasses />
              </ProtectedRoute>
            } 
          />
          <Route 
            exact 
            path="/admin/settings" 
            element={
              <ProtectedRoute>
                <AdminSettings />
              </ProtectedRoute>
            } 
          />
          <Route 
            exact 
            path="/admin/faq" 
            element={
              <ProtectedRoute>
                <AdminFaq />
              </ProtectedRoute>
            } 
          />
          <Route 
            exact 
            path="/admin/testimonials" 
            element={
              <ProtectedRoute>
                <AdminTestimonials />
              </ProtectedRoute>
            } 
          />
          <Route 
            exact 
            path="/admin/facilities" 
            element={
              <ProtectedRoute>
                <AdminFacilities />
              </ProtectedRoute>
            } 
          />
        </Routes>
        </div>
        <Footer />
      </div>
    </Router>
  );
}

export default App;